import { DataFetchWrapper, ErrorBox, Loader } from "@tfg/ui"
import { AxiosError } from "axios"

import { useFindOperationChainsQuery } from "~/pages/Admin/Ingestion/OpChains/hooks/useFindOperationChainsQuery"

import { ProductTypesAdmin } from "./ProductTypesAdmin"
import { useListProductTypesQuery } from "./hooks"

export const ProductTypesAdminWrapper = () => {
  const productTypesQuery = useListProductTypesQuery()
  const {
    data: productOpChains,
    isLoading,
    isError,
    error,
  } = useFindOperationChainsQuery({
    type: "PRODUCT",
    showDeleted: false,
  })

  if (isLoading) {
    return <Loader />
  }
  if (isError) {
    return <ErrorBox error={error as AxiosError} />
  }
  return (
    <DataFetchWrapper query={productTypesQuery}>
      {({ data }) => (
        <ProductTypesAdmin
          productTypes={data}
          productOpChains={productOpChains.data}
        />
      )}
    </DataFetchWrapper>
  )
}
